import { DAYS_FETCH_REQUEST, DAYS_FETCH_SUCCESS, DAYS_FETCH_FAILURE } from './types';
import baseUrl from '../url'

const fetchDaysRequest = () => {
    return {
        type: DAYS_FETCH_REQUEST
    }
}

export const fetchDaysSuccess = days => {
    return {
        type: DAYS_FETCH_SUCCESS,
        payload: days,
    }
}

const fetchDaysFailure = error => {
    return {
        type: DAYS_FETCH_FAILURE,
        payload: error,
    }
}

// const subtractTwoArrays = (arr1, arr2) => arr1.filter(el => !arr2.includes(el));
// const blockedDays = activeDays => {
//     const days = [1, 2, 3, 4, 5, 6, 7];
//     let blockedDays = subtractTwoArrays(days, activeDays)
//     if (Object.keys(blockedDays).length !== 0) {
//         return blockedDays;
//     } else {
//         return [];
//     }
//     return activeDays
// };

export const getDays = slug => {
    return (dispatch) => {
        dispatch(fetchDaysRequest());
        fetch(`${baseUrl}/available_days/${slug}`, {
                method: 'GET'
            })
            .then(response => response.json())
            .then((response) => {
                // let res = blockedDays(response);
                dispatch(fetchDaysSuccess(response));
            })
            .catch((error) => {
                dispatch(fetchDaysFailure(error.message));
            })
    }
}